export const Highlight = ({ children, color = "#FFE440" }) => (
  <span className="relative inline-block px-1" data-testid="highlight-text">
    <span className="relative z-10">{children}</span>
    <span
      className="absolute inset-x-0 bottom-[0.12em] h-[0.5em] -rotate-1 -z-0"
      style={{ backgroundColor: color }}
      aria-hidden="true"
    />
  </span>
);
